var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"py-5 mx-auto"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticStyle:{"max-width":"450px"},attrs:{"cols":"12"}},[_c('txn-status-panel',{ref:"txnStatusPanel",attrs:{"langKey":_vm.langKey,"accentColor":_vm.accentColor}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }